import _, { cloneDeep } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import {
  FormControl as MuiFormControl,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";

import TextInput from "../../../toolkit/TextInput";
import Select from "@mui/material/Select";
import RadioButtons from "../../../toolkit/RadioButtons";
import CheckboxGroup from "../../../toolkit/CheckboxGroup";
import theme from "../../../themes/baseTheme";
// import "../../../styles/FormControl.css";
import ErrorIcon from "@mui/icons-material/Error";
import Number from "../../../toolkit/Number";
import { Button } from "@mui/material";
import Enum from "../../../utils/Enums";

import FinancialData from "../../financialanalytics/FinancialData/FinancialData";
import axios from "../../../utils/fvAxios";
import { useNavigate } from "react-router-dom";

import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/system";
import FormulaReferenceTable from "./FormulaReferenceTable";
const QuestionTypes = {
  Label:1,
  Text: 2,
  Number: 3,
  TextArea: 4,
  Email: 5,
  Radio: 7,
  CheckBox: 8,
  DropDown: 9,
  MultiSelect: 10,
  Date: 11,
  Button: 12,
};

export default function QuestionColumn({
  questionColumnDetails,
  details,
  numberOfColumns,
  columnNo,
  setQuestionColumnDetails,
  repeatColumnLogic,
  setRepeatColumnLogic,
  questionColumnDetail,
  handleQuestionColumnDetailData,
  defaultRepeatLogic,
  disableAll,
  // setRequired,
  ...props
}) {
  const timeoutRef = useRef(null);
  const [questionControlType, setQuestionControlType] = useState(
    questionColumnDetail?.questionControlTypeId
  );
  const [displayType, setDisplayType] = useState(
    questionColumnDetail?.displayType
  );
  const [hasTableReference, setHasTableReference] = useState(
    questionColumnDetail?.tableReference?.qcTableReference?.length > 0
  );
  const [buttonTypeReferenceValue, setButtonTypeReferenceValue] = useState(
    questionColumnDetail?.buttonTypeReferenceValue
  );
  const [hasFormulaReference, setHasFormulaReference] = useState(
    questionColumnDetail?.qFormula?.length > 0
  );
  const [columnOptionValue, setColumnOptionValue] = useState(
    questionColumnDetail?.options
  );
  const [refTableName, setRefTableName] = useState(
    questionColumnDetail?.tableReference?.qcTableReference
  );
  const [localQuestionColumnDetail, setLocalQuestionColumnDetail] = useState(questionColumnDetail);
  const [placeHolderValue, setPlaceHolderValue] = useState(questionColumnDetail?.questionPlaceholder);

  useEffect(() => {
    if (!areObjectsEqual(localQuestionColumnDetail, questionColumnDetail)) {
      setLocalQuestionColumnDetail(questionColumnDetail);
    }
    setQuestionControlType(questionColumnDetail?.questionControlTypeId);
    setColumnOptionValue(questionColumnDetail?.options);
    setButtonTypeReferenceValue(questionColumnDetail?.buttonTypeReferenceValue);
    setRefTableName(questionColumnDetail?.tableReference?.qcTableReference);
    setPlaceHolderValue(questionColumnDetail?.questionPlaceholder);
    setHasFormulaReference(questionColumnDetail?.qFormula?.length > 0);
    setHasTableReference(questionColumnDetail?.tableReference?.qcTableReference?.length > 0);
    setDisplayType(questionColumnDetail?.displayType);

  }, [questionColumnDetail]);

  const handleChangeControlType = (event) => {
    const _type = +event.target.value;
    setQuestionControlType(_type);
    setLocalQuestionColumnDetail((prevState) => {
      return {
        ...prevState,
        questionControlTypeId: _type,
        options:""
      };
    });

    if (_type !== QuestionTypes.DropDown) {
      //not a dropdown
      setHasTableReference(false);
    }
    if (![QuestionTypes.Text, QuestionTypes.TextArea].includes(_type)) {
        setPlaceHolderValue("");
    }
  };
  const handleDisplayType = (event) => {
    const _type = event.target.value;
    setDisplayType(_type);
    setLocalQuestionColumnDetail((prevState) => {
      return {
        ...prevState,
        displayType: _type,
      };
    });
  };

  const handleRepeatDetailLogic = (event) => {
    const _value = event.target.value === "true";
    setRepeatColumnLogic(_value);
    setLocalQuestionColumnDetail((prevState) => ({
      ...prevState,
      repeatLogic: _value,
    }));
  };
  const handleHasTableRefrence = (event) => {
    const _value = event.target.value === "true";
    setHasTableReference(_value);
    if (!_value) {
      setRefTableName(null);
      setLocalQuestionColumnDetail((prevState) => ({
        ...prevState,
        tableReference: null,
      }));
    }
  };
  const handleHasFormulaReference = (event) => {
    setHasFormulaReference(event.target.value === "true");
    if (event.target.value !== "true") {
      setLocalQuestionColumnDetail((prevState) => ({
        ...prevState,
        qFormula: "",
      }));
    }
  };
  const handleButtonTypeReferenceValue = (event) => {
    const _value = +event.target.value;
    setButtonTypeReferenceValue(_value);
    setLocalQuestionColumnDetail((prevState) => ({
      ...prevState,
      buttonTypeReferenceValue: _value,
    }));
  };
  const handleTableRefrence = (event) => {
    const _value = event.target.value;

    const tableReference = {
      qcTableReference: _value,
      qcTableReferenceField: "string",
      qcTableRefFieldValueDisplay: "string",
    };
    setRefTableName(_value);

    setLocalQuestionColumnDetail((prevState) => ({
      ...prevState,
      tableReference: tableReference,
    }));
  };
  const handleColumnValueChange = (value) => {
    setColumnOptionValue(value);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setLocalQuestionColumnDetail((prevState) => ({
        ...prevState,
        options: value,
      }));
    }, 500);
  };
  const handlePlaceHolderValue = (value) => {
    setPlaceHolderValue(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setLocalQuestionColumnDetail((prevState) => ({
        ...prevState,
        questionPlaceholder: value,
      }));
    }, 500);
  };

  const onFormulaVerifySuccess = (_value) => {
    setButtonTypeReferenceValue(_value);
    setLocalQuestionColumnDetail((prevState) => ({
      ...prevState,
      qFormula: _value,
    }));
  };

  useEffect(() => {
    if (!areObjectsEqual(localQuestionColumnDetail, questionColumnDetail)) {
      if (localQuestionColumnDetail.questionControlTypeId === 3) {
        localQuestionColumnDetail.questionPlaceholder = "";
      }
      handleQuestionColumnDetailData(localQuestionColumnDetail, columnNo);
    }
  }, [localQuestionColumnDetail]);

  const areObjectsEqual = (obj1, obj2) => {
    if (obj1 === obj2) {
      return true;
    }

    if (
      typeof obj1 !== "object" ||
      typeof obj2 !== "object" ||
      obj1 === null ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) 
      return false;

    for (const key of keys1) {
      const value1 = obj1[key];
      const value2 = obj2[key];

      if (!areObjectsEqual(value1, value2)) {
        return false;
      }
    }
    return true;
  };
  return (
    <>
      <div className="row mt-2 px-3">
        <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
          <span className="input-label-right">Input Control</span>
        </div>
        <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
          <Select
            value={questionControlType}
            disabled={disableAll}
            size="small"
            placeholder="questionControlTypes"
            name="questionControlTypes"
            id="questionControlTypes"
            className="form-control text-feild-custom mx-2 border-0 px-0"
            onChange={handleChangeControlType}
          >
            <MenuItem value={0}>Select Type</MenuItem>
            {details?.questionControlTypes?.map((r, index) => (
              <MenuItem key={index} value={r.questionTypeID}>
                {r.questionTypeDisplayName}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      {[QuestionTypes.Text, QuestionTypes.TextArea].includes(
        questionControlType
      ) && (
        //Input Value - Text Field , Text Area
        <div className="row mt-2 px-3">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">Place Holder</span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-2">
            <TextField
              disabled={disableAll}
              placeholder= {numberOfColumns > 1?"":"Place Holder text"}
              value={placeHolderValue || ""}
              className="form-control text-feild-custom mx-2"
              onChange={(e) => handlePlaceHolderValue(e.target.value)}
            />
          </div>
        </div>
      )}
      {([
        QuestionTypes.Radio,
        QuestionTypes.CheckBox,
        // QuestionTypes.DropDown,
        QuestionTypes.MultiSelect,
        QuestionTypes.Button,
        QuestionTypes.Label,
      ].includes(questionControlType) ||
      (questionControlType === QuestionTypes.DropDown && !hasTableReference))  && (
        //Input Value - Button , Radio, Check Box, Multi Select, Drop Down
        <div className="row mt-2 px-3">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              Value
              <small style={{ color: "red" }}> *</small>
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-2">
            <TextField
              disabled={disableAll}
              placeholder="Value"
              value={columnOptionValue || ""}
              className="form-control text-feild-custom mx-2"
              onChange={(e) => handleColumnValueChange(e.target.value)}
            />
            <Typography className="text-danger mx-2 mt-1">
              {/* {errors.checklistName?.message} */}
            </Typography>
          </div>
        </div>
      )}

      {questionControlType === QuestionTypes.Number && (
        //Number -- Has Formula Reference	?
        <>
          <div className="row mt-2 px-3 ">
            <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
              <span className="input-label-right">Has Formula Reference</span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
              <RadioGroup
                className="mx-2"
                required
                row
                type="radio"
                value={hasFormulaReference}
                onChange={handleHasFormulaReference}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                  disabled={disableAll}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                  disabled={disableAll}
                />
              </RadioGroup>
            </div>
          </div>
          {/* FormulaReference */}
          {hasFormulaReference && (
            <FormulaReferenceTable
              questionsAndCodes={details?.questionsAndCodes}
              existingFormula={questionColumnDetail?.qFormula}
              onFormulaVerifySuccess={onFormulaVerifySuccess}
            />
          )}
        </>
      )}

      {(questionControlType == QuestionTypes.Radio ||
        questionControlType == QuestionTypes.CheckBox) && (
        //Radio or Check Box
        <div className="row mt-2 px-3">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">Display</span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-2">
            <Select
              value={displayType}
              required
              size="small"
              placeholder="questionControlTypes"
              name="questionControlTypes"
              id="questionControlTypes"
              className="form-control text-feild-custom mx-2 border-0 px-0"
              onChange={handleDisplayType}
              disabled={disableAll}
            >
              <MenuItem value={0}>Horizontal</MenuItem>
              <MenuItem value={1}>Vertical</MenuItem>
            </Select>
          </div>
        </div>
      )}

      {questionControlType === QuestionTypes.DropDown && (
        //Drop Down -- Has Table Reference?
        <>
          <div className="row mt-2 px-3 ">
            <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
              <span className="input-label-right">Has Table Reference</span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
              <RadioGroup
                className="mx-2"
                required
                row
                type="radio"
                value={hasTableReference}
                onChange={handleHasTableRefrence}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                  disabled={disableAll}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                  disabled={disableAll}
                />
              </RadioGroup>
            </div>
          </div>
          {/* Table Reference */}
          {hasTableReference && (
            <div className="row mt-2 px-3 ">
              <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                <span className="input-label-right">
                  Table Name
                  <small style={{ color: "red" }}> *</small>
                </span>
              </div>
              <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                <Select
                  value={refTableName}
                  required
                  size="small"
                  placeholder="questionControlTypes"
                  name="questionControlTypes"
                  id="questionControlTypes"
                  className="form-control text-feild-custom mx-2 border-0 px-0"
                  onChange={handleTableRefrence}
                  disabled={disableAll}
                >
                  <MenuItem value={null}>Select</MenuItem>
                  <MenuItem value="BiddingInterests">
                    Bidding Interests
                  </MenuItem>
                  <MenuItem value="ClaycoBiddingInterests">
                    Clayco Bidding Interests
                  </MenuItem>
                  <MenuItem value="ClientContractTypes">
                    Client Contract Types
                  </MenuItem>
                  <MenuItem value="CanadianProvinces">
                    Canadian Provinces
                  </MenuItem>
                  <MenuItem value="UnitedStates">
                    United States of America
                  </MenuItem>
                </Select>
              </div>
            </div>
          )}
        </>
      )}

      {questionControlType === QuestionTypes.Button && (
        //Button -- ButtonTypeReferenceValue?
        <>
          <div className="row mt-2 px-3 ">
            <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
              <span className="input-label-right">
                Button Type
                <small style={{ color: "red" }}> *</small>
              </span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
              <RadioGroup
                className="mx-2"
                type="radio"
                value={buttonTypeReferenceValue}
                onChange={handleButtonTypeReferenceValue}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio />}
                  label="Sub-Section Interim Save"
                  disabled={disableAll}
                />
                <FormControlLabel
                  value={2}
                  control={<Radio />}
                  label="Financial Analytics"
                  disabled={disableAll}
                />
              </RadioGroup>
            </div>
          </div>
        </>
      )}

      {columnNo === 1 && numberOfColumns > 1 && (
        //Repeat Logic Radio
        <div className="row mt-2 px-3">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              Repeat the above details for remaining columns:
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <RadioGroup
              className="mx-2"
              required
              row
              type="radio"
              value={repeatColumnLogic}
              onChange={handleRepeatDetailLogic}
            >
              <FormControlLabel
                disabled={disableAll}
                value={true}
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                disabled={disableAll}
                value={false}
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </div>
        </div>
      )}
    </>
  );
}
